import { SeoLanguageLocale, getSeoLanguageLocale } from 'src/utils/getSeoLanguageLocale';
import sourceLanguagesData from './sourceLanguages.data.json';

type LabelMap = { [key: SeoLanguageLocale]: string };

export const LABEL_MAP = sourceLanguagesData.reduce((labelMap: LabelMap, { locale, name }) => {
  labelMap[getSeoLanguageLocale(locale)] = name;
  return labelMap;
}, {});
